import { render, staticRenderFns } from "./TeacherIndividualEntitlementPage.vue?vue&type=template&id=4c8783ee&scoped=true&"
import script from "./TeacherIndividualEntitlementPage.vue?vue&type=script&lang=js&"
export * from "./TeacherIndividualEntitlementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8783ee",
  null
  
)

export default component.exports